/**
 * Post-exam Correct/Incorrect using the same yes/no and most/least rules as getStats.
 * Do not use ans.label === q.correct_answer for widget rows.
 */

function yesNoMap(ans) {
  if (ans?.yes_no_answers && typeof ans.yes_no_answers === 'object' && !Array.isArray(ans.yes_no_answers)) {
    return ans.yes_no_answers;
  }
  if (Array.isArray(ans?.yes_no)) {
    const map = {};
    ans.yes_no.forEach((item) => {
      if (item?.yes_no_item_id != null) map[String(item.yes_no_item_id)] = Boolean(item.answered_yes);
    });
    return map;
  }
  return {};
}

function mostLeastIds(ans) {
  if (ans?.most_least_answers) {
    return {
      most: ans.most_least_answers.most_option_id,
      least: ans.most_least_answers.least_option_id,
    };
  }
  return { most: ans?.most_option_id, least: ans?.least_option_id };
}

export function isYesNoQuestionForReview(q) {
  return Boolean(
    q
    && q.interaction_kind === 'yes_no_group'
    && Array.isArray(q.yes_no_items)
    && q.yes_no_items.length > 0
  );
}

export function isMostLeastQuestionForReview(q) {
  return Boolean(
    q
    && q.interaction_kind === 'most_least_group'
    && Array.isArray(q.most_least_options)
    && q.most_least_options.length > 0
  );
}

export function isYesNoCorrect(q, ans) {
  const yn = yesNoMap(ans);
  const items = q.yes_no_items || [];
  const complete = items.every((it) => String(it.id) in yn);
  return complete && items.every((it) => yn[String(it.id)] === !!it.correct_yes);
}

export function isMostLeastCorrect(q, ans) {
  const { most, least } = mostLeastIds(ans);
  const mostOpt = (q.most_least_options || []).find((o) => o.is_correct_most);
  const leastOpt = (q.most_least_options || []).find((o) => o.is_correct_least);
  return Boolean(
    mostOpt
    && leastOpt
    && String(most) === String(mostOpt.id)
    && String(least) === String(leastOpt.id)
  );
}

export function pearsonReviewRowStatus(q, ans, { visited = false, isQuestionAnswered } = {}) {
  const answered = typeof isQuestionAnswered === 'function'
    ? isQuestionAnswered(q)
    : Boolean(
      (ans && ans.label)
      || (isYesNoQuestionForReview(q) && (q.yes_no_items || []).every((it) => String(it.id) in yesNoMap(ans)))
      || (isMostLeastQuestionForReview(q) && mostLeastIds(ans).most && mostLeastIds(ans).least)
    );
  if (!visited && !answered) {
    return { status: 'Unseen', tone: 'unseen' };
  }
  if (isYesNoQuestionForReview(q)) {
    return isYesNoCorrect(q, ans)
      ? { status: 'Correct', tone: 'correct' }
      : { status: 'Incorrect', tone: 'incorrect' };
  }
  if (isMostLeastQuestionForReview(q)) {
    return isMostLeastCorrect(q, ans)
      ? { status: 'Correct', tone: 'correct' }
      : { status: 'Incorrect', tone: 'incorrect' };
  }
  if (ans && ans.label && ans.label === q.correct_answer) {
    return { status: 'Correct', tone: 'correct' };
  }
  return { status: 'Incorrect', tone: 'incorrect' };
}
